// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NQ5iM","type":"styles_type__2aZOe","choices":"styles_choices__3d53K"};